import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

const paddingLeft = Constants.PagePadding.smallMainSectionLeftPadding;

export const getTabBarStyles = (_, { palette = {} }) => ({
  menuContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    marginLeft: '23px',
    '& .ms-Pivot': {
      height: '100%',
      overflow: 'hidden',
      '& .ms-Button': {
        height: '100%',
        outlineOffset: '-1px',
        '& a': {
          textDecoration: 'none',
        },
        '& .category-score-upLift': {
          display: 'inline',
          marginLeft: 8,
          fontWeight: 600,
          fontSize: 18,
          color: palette.themePrimary,
        },
      },
    },
    '&.campaigns, &.adgroups, &.ads-and-extensions, &.keywords, &.audiences': {
      marginLeft: paddingLeft - 8, // 8 is internal tab button padding
    },
    '& #bingads-campaign-react-sub-page-menu-tabs-tab-Dismissed:before': {
      backgroundColor: palette.neutralQuaternaryAlt,
      bottom: 14,
      width: 1,
      content: '\'\'',
      height: 30,
      left: -4,
      position: 'absolute',
    },
    '& button.ms-Pivot-link:active #bingads-campaign-react-sub-page-menu-tabs-tab-Dismissed:before': {
      left: -12,
    },
  },
  onlyOneTabItem: {
    '& .nav-tabs>li.active': {
      '&:hover': {
        backgroundColor: palette.white,
      },

      '& a': {
        fontSize: '26px !important',
        '&:before': {
          border: 'none',
        },
        '&:hover': {
          backgroundColor: palette.white,
        },
      },
    },
  },
  notAvailableTextContainer: {
    color: palette.white,
    '&:hover': {
      color: palette.themePrimary,
      textDecoration: 'none',
      '& .iconba-OpenInNewWindow': {
        opacity: 1,
      },
    },
    '&:active': {
      color: palette.themePrimary,
      textDecoration: 'none',
      '& .iconba-OpenInNewWindow': {
        opacity: 1,
      },
    },
    '&:focus': {
      color: palette.themePrimary,
      textDecoration: 'none',
      '& .iconba-OpenInNewWindow': {
        opacity: 1,
      },
    },
    textDecoration: 'none',
  },
  availableTextContainer: {
    color: palette.white,
    textDecoration: 'none',
  },
  selectedTextContainer: {
    color: palette.white,
  },
  fallBackTextContainer: {
    color: palette.themePrimary,
    '& .iconba-OpenInNewWindow': {
      opacity: 1,
    },
  },
  text: {
    color: palette.neutralPrimary,
  },
  fallbackGlyph: {
    fontSize: 16,
    paddingLeft: '3px',
    color: 'inherit',
    opacity: 0,
  },
  singleItem: {
    fontSize: 26,
    fontWeight: 800,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 8,
    paddingRight: 8,
    marginRight: 8,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  expandButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
